import { render, staticRenderFns } from "./BookingUiV2.vue?vue&type=template&id=381d9a2a&scoped=true"
import script from "./BookingUiV2.vue?vue&type=script&lang=js"
export * from "./BookingUiV2.vue?vue&type=script&lang=js"
import style0 from "./BookingUiV2.vue?vue&type=style&index=0&id=381d9a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381d9a2a",
  null
  
)

export default component.exports